import { instance } from '../instance';

export const applyStsToken = (param) => instance.post('aliyun/sts/applyststoken', param);

export const invalidStsToken = (param) => instance.post('aliyun/sts/invalidststoken', param);
